import Button from "@components/Button/Button";
import type { CustomButtonProps } from "@components/Button/Button.types.ts";

/** Wireframe-style button for the dry-bulk nomination screens: the shared Button without the upper-casing (DBVN-0021, R-A). */
const DryBulkButton: React.FC<CustomButtonProps> = ({ sx, ...rest }) => (
  <Button {...rest} sx={{ textTransform: "none", ...sx }} />
);

export default DryBulkButton;
